import UrlHelper from '../../common/helpers/urlHelpers'
import Window from '../models/window'
import Embed from '../models/embed'
import User from '../models/user'

class Model {
  constructor() {

    this.Window = Window.createWindow();

    this.Embed = Embed.create();

    this.ProductCategory = this.initProductCategory();

    this.Usuario = User.createUser();

    this.CanalDeVenta = this.initCanaldeVenta();
    /*this.Campania = {};
    this.Landing = {};
    //this.PlanElegido = {}

    this.idOrigen = 0;

    this.ComboAccesoSuscripcion = false;
    this.YaTieneSuscripcion = false;

    this.Cliente = {
      apellido: "",
      email: "",
      nombre: "",
      numeroDocumento: "",
      telefonoCelular: "",
      telefonoInterno: "",
      tipoDocumento: "",
      planElegido: null,
      mailOfuscado: ""
    }

    this.SWGSubscriptions = null

    */


    //TODO: EP
    //this.Variant = Helper.getPaywallVariant();

    //this.Usuario.SitioId = this.Window.SitioId;
  }

  initCanaldeVenta() {
    if (UrlHelper.getURLParameter('cv') !== null) {
      return UrlHelper.getURLParameter('cv');
    }
    else {
      return 0;
    }
  }

  initProductCategory() {
    if (UrlHelper.getURLParameter('productCategory') !== null) {
      return UrlHelper.getURLParameter('productCategory'); 
    }
  }

  mapProductCategory(productCategory) {
    if (!this.ProductCategory) {
      if (productCategory) {
        this.ProductCategory = productCategory
      }
    }
  }

  mapCanaldeVenta(canal) {
      if (this.CanalDeVenta == 0) {
        if (canal && canal!=null) {
          this.CanalDeVenta = canal
        }
      }
    }
  }

let model = new Model();

module.exports = {
  model
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/model.js